import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-vertx',
	templateUrl:'./VertxPluginPage.html',
	styles: [],
	styleUrls:['./VertxPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class VertxPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_668 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp</groupId>
  <artifactId>jwebmp-vertx</artifactId>
</dependency>
\`\`\``;
	mdContent_669 = `\`\`\`kotlin
implementation("com.jwebmp:jwebmp-vertx:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_670 = `\`\`\`java
@PageConfiguration(url = "/")
public class HomePage extends Page<HomePage> {
    public HomePage() {
        getBody().add(
            new H1<>().setText("Hello from JWebMP")
        );
    }
}
\`\`\``;
	mdContent_671 = `\`\`\`java
IGuiceContext.instance().inject();
// Routes auto-registered:
// GET /       -> Page rendering
// POST /jwajax -> AJAX events
// GET /jwdata  -> Data components
// GET /jwcss   -> Page CSS
\`\`\``;
	mdContent_672 = `\`\`\`java
@PageConfiguration(url = "/")
public class HomePage extends Page<HomePage> {
    public HomePage() {
        getBody().add(
            new H1<>().setText("Hello from JWebMP")
        );
    }
}

// Start the server
IGuiceContext.instance().inject();
// Routes auto-registered:
// GET /      → HomePage
// POST /jwajax → AJAX events
// GET /jwdata  → data components
// GET /jwcss   → page CSS
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
